<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest}>
	<path
		d="M20.7117 6.70247C21.0997 6.3094 21.0955 5.67625 20.7025 5.28829C20.3094 4.90032 19.6763 4.90446 19.2883 5.29753L9.13209 15.5874L4.70092 11.2327C4.30701 10.8456 3.67387 10.8511 3.28676 11.245C2.89965 11.6389 2.90517 12.2721 3.29908 12.6592L8.44194 17.7132C8.83524 18.0998 9.4672 18.0949 9.85457 17.7025L20.7117 6.70247Z"
		fill={getTailwindColor(color)}
	/>
</SvgWrapper>
